import HTTP from '../libs/HTTP';

//query接口请求参数
export interface CompanyQueryByIdParam {
    id: number;
}
export interface CompanyQueryParam {
    id?: number;
    name?: string;
    states?: number;
    sales?: number;
    nature?: string;
}
export interface CompanyListRequest {
    companyQueryParam: CompanyQueryParam;
    pageNo: number;
    pageSize: number;
}

//query接口返回参数
export interface ICompanyInfoList {
    records: ICompanyInfo[];
    total: number;
    size: number;
    current: number;
    pages: number;
}
export interface ICompanyInfo {
    id: number;
    name: string;
    ename?: string | null;
    country?: string | null;
    province?: string | null; 
    address?: string | null; 
    nature?: string | null; 
    industry?: string | null; 
    website?: string | null; 
    postal?: string | null; 
    phone?: string | null; 
    fax?: string | null; 
    level?: string | null; 
    sales?: string | null; 
    remark?: string | null; 
    states: number;
}

//add接口请求参数
export interface CompanyPostParam {
    name: string;
    ename?: string | null;
    country?: string | null;
    province?: string | null; 
    address?: string | null; 
    nature?: string | null; 
    industry?: string | null; 
    website?: string | null; 
    postal?: string | null; 
    phone?: string | null; 
    fax?: string | null; 
    level?: string | null; 
    sales?: string | null; 
    remark?: string | null; 
    states: number;
}

//edit接口请求参数
export interface CompanyPutParam {
    id: number;
    name?: string;
    ename?: string;
    country?: string;
    province?: string; 
    address?: string; 
    nature?: string; 
    industry?: string; 
    website?: string; 
    postal?: string; 
    phone?: string; 
    fax?: string; 
    level?: string; 
    sales?: number; 
    remark?: string; 
    states?: number;
}

export interface AssignSalesParam {
    companyIds: number[];
    salesId: number | null;
}

class CompanyService extends HTTP {
    //根据查询条件查询公司信息
    async getCompanyListInfo(request: CompanyListRequest) {
        const response = await this.post('/company/getCompany', request.companyQueryParam, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //查询登录账号的公司信息
    async getCompanyByLoginAccount(request: CompanyListRequest) {
        const response = await this.post('/company/getCompanyByLoginAccount/', request.companyQueryParam, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        if (response && response.data) {
            return response.data;
        }
    }
    
    //根据id查询公司信息
    async getCompanyInfoById(id: number) {
        const response = await this.get(`/company/getCompanyById/${id}`);
        if (response && response.data) {
            return response.data;
        }
    }

    //添加公司信息
    async addCompany(request: CompanyPostParam) {
        const response = await this.post('/company/addCompany', request, {
            params: {
                name: request.name,
                ename: request.ename,
                country: request.country,
                province: request.province, 
                address: request.address, 
                nature: request.nature, 
                industry: request.industry,
                website: request.website, 
                postal: request.postal, 
                phone: request.phone, 
                fax: request.fax, 
                level: request.level, 
                sales: request.sales, 
                remark: request.remark, 
                states: request.states,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //编辑公司信息
    async updateCompany(request: CompanyPutParam) {
        const response = await this.put(`/company/updateCompany/${request.id}`, request, {
            params: {
                name: request.name,
                ename: request.ename,
                country: request.country,
                province: request.province, 
                address: request.address, 
                nature: request.nature, 
                industry: request.industry,
                website: request.website, 
                postal: request.postal, 
                phone: request.phone, 
                fax: request.fax, 
                level: request.level, 
                sales: request.sales, 
                remark: request.remark, 
                states: request.states,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //指派销售给指定客户公司
    async assignSalesByCompanyIds(request: AssignSalesParam) {
        const response = await this.put('/company/assignSalesByCompanyIds', request);
        if (response) {
            return response.data;
        }
    }
}
export default new CompanyService();
